/*
* 性能监控
* */

'use strict';

var React = require('react');
var timeLogHelper = require('../../helper/timeLogHelper');

var RenderTimePanel = React.createClass({
  getInitialState: function () {
    return {
      selected: 0,
      componentRenderLogs: [],
      pageRenderLogs: [],
      pageReadLogs: []
    };
  },
  componentDidMount: function () {
    var self = this;
    timeLogHelper.addCallback(function (componentRenderLogs, pageRenderLogs, pageReadLogs) {
      self.setState({
        componentRenderLogs: componentRenderLogs,
        pageRenderLogs: pageRenderLogs,
        pageReadLogs: pageReadLogs
      });
    });
  },
  render: function () {
    return (
      <div className="logs" draggable="true">
        <h3>性能监控</h3>
        <ul className="segment">
          <li onClick={this.onSelect.bind(this, 0)} className={this.state.selected === 0 ? 'current' : ''}>页面读取</li>
          <li onClick={this.onSelect.bind(this, 1)} className={this.state.selected === 1 ? 'current' : ''}>页面渲染</li>
          <li onClick={this.onSelect.bind(this, 2)} className={this.state.selected === 2 ? 'current' : ''}>组件渲染</li>
        </ul>
        <div className="scroll-area">
          <div
            style={{
              display: this.state.selected === 0 ? 'block' : 'none'
            }}
          >
            <table>
              <thead>
              <tr>
                <td>名称</td>
                <td>耗时</td>
              </tr>
              </thead>
              <tbody>
              {
                this.state.pageReadLogs.map(function (item) {
                  return (
                    <tr key={item[0]}>
                      <td>{item[3]}</td>
                      <td>{item[2]}ms</td>
                    </tr>
                  )
                })
              }
              </tbody>
            </table>
          </div>
          <div
            style={{
              display: this.state.selected === 1 ? 'block' : 'none'
            }}
          >
            <table>
              <thead>
              <tr>
                <td>名称</td>
                <td>次数</td>
                <td>平均耗时</td>
              </tr>
              </thead>
              <tbody>
              {this.state.pageRenderLogs.map(function (item) {
                return (
                  <tr key={item[0]}>
                    <td title={item[0]}>{item[3]}</td>
                    <td>{item[1]}</td>
                    <td>{item[2]}ms</td>
                  </tr>
                )
              })}
              </tbody>
            </table>
          </div>
          <div
            style={{
              display: this.state.selected === 2 ? 'block' : 'none'
            }}
          >
            <table>
              <thead>
              <tr>
                <td>组件</td>
                <td>次数</td>
                <td>平均耗时</td>
              </tr>
              </thead>
              <tbody>
              {this.state.componentRenderLogs.map(function (item) {
                return (
                  <tr key={item[0]}>
                    <td>{item[0]}</td>
                    <td>{item[1]}</td>
                    <td>{item[2]}ms</td>
                  </tr>
                )
              })}
              </tbody>
            </table>
          </div>
        </div>
        <span className="reset" onClick={this.onReset}>重置</span>
      </div>
    );
  },
  onSelect: function (idx) {
    this.setState({
      selected: idx
    });
  },
  onReset: function () {
    timeLogHelper.reset();
  }
});

module.exports = RenderTimePanel;



// WEBPACK FOOTER //
// ./src/views/Dev/RenderTimePanel.jsx